import CreateProspectForm from "src/components/forms/auth/signup/company/CreateProspectForm";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import AuthLayout from "src/components/layout/AuthLayout/AuthLayout";

function SignupCompanyView({ t }: Translation) {
	return (
		<AuthLayout
			head={{
				title: t("title"),
				back: {
					to: "/signup",
					label: t("back"),
				},
			}}
		>
			<CreateProspectForm />
		</AuthLayout>
	);
}

SignupCompanyView.locale = {
	nl: {
		title: "Ik wil opdrachten plaatsen",
		back: "Terug naar aanmelden",
	},
	en: {
		title: "I want to outsource tasks",
		back: "Back to signup",
	},
};
export default withTranslation(SignupCompanyView);
